<div class="settings-vvvo-hit-layout">
    <div class="settings-vvvo-hit-page">
        <div class="list-title-row">
            <button mat-icon-button color="accent" (click)="goBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <h3 class="list-title">Betrieb hinzufügen</h3>
        </div>
        <h3 class="settings-vvvo-hit-step-title">1. HIT Konto verknüpfen</h3>
        <div class="settings-vvvo-hit-form-shell">
            <hit-anmeldung [navigateToAfterLogin]="'../details'"></hit-anmeldung>
        </div>
    </div>
</div>
